function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  transform: "translate(.656 .924)"
}, React.createElement("rect", {
  fill: "#FFF",
  x: 21.245,
  y: 6.068,
  width: 8.093,
  height: 2.023,
  rx: 1.011
}), React.createElement("rect", {
  fill: "#FFF",
  x: 13.151,
  y: 93.044,
  width: 24.279,
  height: 2.023,
  rx: 1.011
}), React.createElement("rect", {
  stroke: "#FFF",
  strokeWidth: 2,
  x: 1,
  y: 1,
  width: 48.582,
  height: 99.135,
  rx: 8
})), React.createElement("g", {
  id: "screen-search"
}, React.createElement("path", {
  d: "M72.77 73.172l-.176-.196-.83.746-.053.05a2.908 2.908 0 011.059-.6zm-1.06.6l-.099.095a2.62 2.62 0 01.1-.094zm-9.135-6.267h1.242a2.967 2.967 0 01-2.081-.84l.84.84zm14.593 12.117c-.935.888-2.147 1.406-3.476 1.406a4.78 4.78 0 01-3.615-1.627l-9.17-9.167c-.888.51-1.82.958-2.792 1.344a21.043 21.043 0 01-7.825 1.486c-3.861 0-7.454-.963-10.703-2.877a21.436 21.436 0 01-7.68-7.678c-1.915-3.249-2.878-6.84-2.878-10.702 0-3.86.963-7.453 2.878-10.7a21.436 21.436 0 017.68-7.679c3.25-1.914 6.842-2.877 10.703-2.877 3.862 0 7.454.963 10.703 2.877a21.436 21.436 0 017.68 7.678c1.916 3.248 2.878 6.84 2.878 10.701 0 2.716-.496 5.333-1.486 7.824a21.678 21.678 0 01-1.313 2.737l9.345 9.342c.954.953 1.421 2.2 1.421 3.493a5.212 5.212 0 01-1.05 3.147l-.233.312-1.067.96zm-8.416-17.254a20.784 20.784 0 01-2.834 3.86l-2.93-2.723v-4h.829c1.376 0 2.628.556 3.575 1.503l1.36 1.36z",
  stroke: "#7034A0",
  strokeWidth: 8,
  fill: "#70349F",
  fillRule: "nonzero"
}), React.createElement("path", {
  d: "M75.27 74.539c.165.166.248.387.248.664 0 .276-.083.525-.249.746l-.83.747c-.221.221-.47.332-.747.332a.789.789 0 01-.663-.332L62.323 65.994a.788.788 0 01-.332-.664v-.83a17.027 17.027 0 01-5.352 3.36 17.043 17.043 0 01-6.349 1.204c-3.153 0-6.044-.775-8.672-2.323a17.437 17.437 0 01-6.265-6.264c-1.55-2.627-2.324-5.517-2.324-8.67 0-3.152.775-6.042 2.324-8.67a17.437 17.437 0 016.265-6.263c2.628-1.548 5.519-2.323 8.672-2.323 3.154 0 6.044.775 8.672 2.323a17.437 17.437 0 016.266 6.264c1.549 2.627 2.323 5.517 2.323 8.67a17.03 17.03 0 01-1.203 6.346 17.02 17.02 0 01-3.36 5.351h.829c.277 0 .526.11.747.332l10.705 10.702zm-24.98-8.13c2.656 0 5.104-.65 7.345-1.95 2.24-1.3 4.01-3.07 5.31-5.31 1.3-2.24 1.95-4.687 1.95-7.342 0-2.654-.65-5.102-1.95-7.342-1.3-2.24-3.07-4.01-5.31-5.31-2.241-1.299-4.69-1.949-7.345-1.949-2.655 0-5.103.65-7.344 1.95a14.386 14.386 0 00-5.311 5.31c-1.3 2.24-1.95 4.687-1.95 7.341 0 2.655.65 5.103 1.95 7.343 1.3 2.24 3.07 4.01 5.311 5.31 2.24 1.299 4.689 1.949 7.344 1.949z",
  fill: "#FFF",
  fillRule: "nonzero"
})));

var SvgSearch = function SvgSearch(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 84 103",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSearch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/search.ffee6d02.svg";
export { ForwardRef as ReactComponent };